import React, { useState, useEffect } from 'react';
import { Form, Button, Select, InputNumber, Slider, Upload, Input, message } from 'antd';
import InputRules from '../../data/InputRules';
import { connect } from 'react-redux';
import { Actions } from '../../store/actions';

const { TextArea } = Input;

const layout = {
	labelCol: {
		span: 4,
	},
	wrapperCol: {
		span: 8,
	},
};
const tailLayout = {
	wrapperCol: {
		offset: 4,
		span: 16,
	},
};

const SuggestionPostForm = ({ addSuggestion }) => {
	const onFinish = async (values) => {
		await addSuggestion(values);
	};

	const onFinishFailed = (errorInfo) => {
		message.error('Something went wrong!');
	};

	const handleChange = ({ fileList }) => {
		setFileList(fileList);
	};

	return (
		<Form
			{...layout}
			name="suggestionPostForm"
			initialValues={{ remember: true }}
			onFinish={onFinish}
			onFinishFailed={onFinishFailed}
		>
			<Form.Item label="Title" name={['title']} rules={InputRules.name}>
				<Input placeholder="Enter Title" />
			</Form.Item>
			<Form.Item label="Description" name={['description']} rules={InputRules.name}>
				<TextArea placeholder="Enter suggestion description" />
			</Form.Item>
			<Form.Item label="Reading Link" name={['readingLink']} rules={InputRules.required('Please enter keywords!')}>
				<Input placeholder="Enter Reading Link" />
			</Form.Item>
			<Form.Item label="Video Link" name={['videoLink']} rules={InputRules.required('Please enter keywords!')}>
				<Input placeholder="Enter Video Link" />
			</Form.Item>
			<Form.Item label="Status" name={['status']} rules={InputRules.required('Please select Status')}>
				<Select showSearch allowClear={true} placeholder="Select Status">
					<Select.Option value="1">True</Select.Option>
					<Select.Option value="0">False</Select.Option>
				</Select>
			</Form.Item>
			<Form.Item label="Keywords" name="keywords" rules={InputRules.required('Please enter keywords!')}>
				<Select mode="tags"></Select>
			</Form.Item>
			<Form.Item {...tailLayout}>
				<Button type="primary" htmlType="submit">
					Add Suggestion
				</Button>
			</Form.Item>
		</Form>
	);
};

const mapStateToProps = (store) => ({});

const mapDispatchToProps = (dispatch) => ({
	addSuggestion: (body) => dispatch(Actions.addSuggestion(body)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SuggestionPostForm);
